var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemButton as MuiListItemButton, } from "@mui/material";
import { useMemo } from "react";
import { COLORS, HALO } from "../../../constants";
var getListButtonStyles = function (size) { return ({
    height: size === "medium" ? 42 : size === "large" ? 44 : 40,
    px: 3,
    borderRadius: 2,
    ".MuiListItem-root": {
        px: 0,
    },
    minWidth: 224,
    maxWidth: "100%",
    "&:hover": {
        background: COLORS.SECONDARY_HOVER,
    },
    "&:active": {
        background: COLORS.SECONDARY_PRESSED,
    },
    "&:focus-visible": {
        boxShadow: HALO,
    },
}); };
var ListItemButton = function (_a) {
    var selectOption = _a.selectOption, children = _a.children, id = _a.id, _b = _a.size, size = _b === void 0 ? "small" : _b;
    var styles = useMemo(function () { return getListButtonStyles(size); }, [size]);
    // call click handle with id of what was clicked
    var clickHandler = function () {
        selectOption(id);
    };
    return (_jsx(MuiListItemButton, __assign({ disableRipple: true, onClick: clickHandler, sx: styles }, { children: children })));
};
export default ListItemButton;
